/**
 * @file
 * Patria box highlights module functionality.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.imageCaptionModule = {
    attach: () => {
      if(window.innerWidth < 768) {
        console.log("Mobile");
        return;
      }
      console.log("Desktop");
      console.log(window.innerWidth);

      const moduleClass = '.paragraph--type--image-and-caption';

      // Register the ScrollTrigger plugin with GSAP.
      gsap.registerPlugin(ScrollTrigger);

      // Check if box highlights exist on the page.
      if ($(moduleClass).length === 0) {
        return;
      }

      const imageCaptionModules = gsap.utils.toArray(moduleClass);
      imageCaptionModules.forEach(imageCaptionModule => {
        // Add timeline animation for the box highlights.
        
        let tl = gsap.timeline();
        
        // For each textField, create a timeline animation.
        const textFields = imageCaptionModule.querySelectorAll(moduleClass + ' .field--name-field-ingress');
        textFields.forEach((textField, index) => {
          var animation = tl.from(textField, {
              y: (imageCaptionModule.offsetHeight * 0.05),
              transformOrigin: "top center", 
              ease: "none"
            }).to(textField, {y: function(i, el) {return (0.9 * (imageCaptionModule.offsetHeight - textField.offsetHeight));} ,
              ease: "none",
              scrollTrigger: {
                trigger: imageCaptionModule,
                start: "top bottom-=400",
                end: "+=600",
                invalidateOnRefresh: true,
                scrub: 0
              }
            }, 0);
        });
      });
    }
  };

})(jQuery, Drupal);
